import * as React from 'react';
import { FormFieldProps } from '..';
import { SelectFieldModel } from '.';
import { Select, Option } from 'informed';
import { FormGroup } from 'reactstrap';
import classNames from 'classnames';
import { FormValue } from 'informed';
import { validateSelect } from '../form.utils';
import { FormErrorField } from '../FormError';
import { LabelCustom as Label } from '../..';

export const SelectField = (props: FormFieldProps<SelectFieldModel>) => {
  const {
    fieldId, 
    field, 
    error, 
    touched, 
  } = props;

  // const fieldProps: FieldProps & React.InputHTMLAttributes<HTMLInputElement> = createFieldProps(field, error, touched, fieldId);

  return (
    <FormGroup key={fieldId} className="position-relative">
      <Label for={fieldId} mandatory={field.required} >
        {field.label}
      </Label>
      {error && touched && field.errorMessage && (
        <FormErrorField errorMessage={field.errorMessage || error[field.name]} tooltip={fieldId} />
      )}
      <Select
        className={classNames('form-control py-0', {'is-invalid': error && touched})} 
        id={fieldId}
        field={field.name} 
        name={field.name}
        validateOnChange={field.required}
        validateOnBlur={field.required}
        validate={(value: FormValue) => 
          field.required && validateSelect(
            value, 
            field
          ) || undefined}
      >
        {field.options && field.options.map((option, oIndex) => (
          <Option
            key={`${fieldId}_option_${oIndex}`} 
            value={option.value as string}
            disabled={option.disabled && field.required}
          >
            {option.label}
          </Option>
        ))}
      </Select>
    </FormGroup>
  );
};